export default "__VITE_ASSET__0d75dbe7__"